// Feature flags via Unleash React SDK.
// Flags are fetched from the Unleash Frontend API at runtime.
// Toggle flags from the Unleash admin UI — no redeploy needed.

import { useFlag } from '@unleash/proxy-client-react'

/** Hook to get all feature flags. Call inside React components only. */
export function useFeatureFlags() {
  return {
    /** Test payment of 20 THB */
    testPayment20thb: useFlag('test_payment_20thb'),
    /** Incentives rewards: points balance, QR coupons, catalog, redemption history */
    loyaltyPoints: useFlag('loyalty_points'),
    /** Incentives retention: cross-account retention PDPA consent screen */
    renewalBenefits: useFlag('renewal_benefits'),
    /** EP-99 WIN pickup relay (dual-gate: this flag AND account.win_pickup_enabled) */
    winPickup: useFlag('win_pickup'),
  }
}

export type FeatureFlags = ReturnType<typeof useFeatureFlags>
